import { render, staticRenderFns } from "./docCHDP.vue?vue&type=template&id=1aebf356&scoped=true"
import script from "./docCHDP.vue?vue&type=script&lang=js"
export * from "./docCHDP.vue?vue&type=script&lang=js"
import style0 from "./docCHDP.vue?vue&type=style&index=0&id=1aebf356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aebf356",
  null
  
)

export default component.exports